$.widget('sensibio.tabs', {
	options: {
		selectors: {
			tab: '[data-role=tab]',
			content: '[data-role=content]'
		},
		classes: {
			active: '_active',
		},
	},

	_create() {
		this._bind();
	},

	_bind() {
		this._cache();
		this._events();
	},

	_cache() {
		const { selectors } = this.options;

		this.$element = $(this.element);
		this.$tab = this.$element.find(selectors.tab);
		this.$content = this.$element.find(selectors.content);
	},

	_events() {
		this._on(this.$tab, {
			click: this.onTabClick,
		});
	},

	onTabClick(event) {
		const { classes } = this.options;
		const $element = $(event.currentTarget);
		const tabId = $element.data('tab');

		this.$tab.removeClass(classes.active);
		this.$content.removeClass(classes.active);

		$element.addClass(classes.active);
		$('#' + tabId).addClass(classes.active);
	}
});